export default __webpack_public_path__ + "static/media/visi-misi.1b1a59f2.jpg";